<template>
    <div class="absolute inset-0">
        <img
            :src="hud"
            alt=""
            class="pointer-events-none absolute top-0 left-1/2 max-w-none -translate-x-1/2"
        />
        <div class="absolute inset-x-0 top-[24px] flex items-center justify-center gap-6">
            <span class="font-title text-xs font-bold text-white uppercase">
                {{ $t('killer.players') }}
            </span>
            <span class="-skew-x-12 bg-white px-3 py-1">
                <span class="font-title block skew-x-12 text-xs font-black text-black italic">
                    {{ players.length }}/{{ players.length }}
                </span>
            </span>
        </div>
        <KillerPlayerCardList
            :players="players"
            icon="skull"
            :max-card-width="246"
            :height="685"
            class="absolute inset-x-0 top-[80px]"
        />
    </div>
</template>

<script>
import KillerPlayerCardList from '../ui/KillerPlayerCardList.vue'
import hud from '@/assets/images/games/killer/splash/hud-turn.svg'

export default {
    name: 'KillerSplashStart',
    components: { KillerPlayerCardList },
    props: {
        players: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            hud,
        }
    },
}
</script>
